export default {
  articleManagement: {
    taggingStatus: {
      filterLabel: 'Tagging Status',
      filterPlaceholder: 'Select tagging status',
      colTitle: 'Tags / Tagging',
      editAction: 'Edit Tags',
      pending: 'Pending',
      tagged: 'Tagged',
      toBeTagged: 'To Re-tag',
    },
    tagEdit: {
      title: 'Edit Article Tags',
      placeholder: 'Pick 2-4 from enabled tags',
      countHint: 'Recommended: {min}-{max} tags ({count} selected)',
      saveOk: 'Tags saved',
      loadTagsFail: 'Failed to load tag dictionary',
      loadCurrentFail: 'Failed to load current tags, please re-select',
    },
      aiReworkBtn: "AI Rewrite",
      submitOnlyDraft: "Only draft articles can be submitted for review",
    title: 'Article Management',
    addNew: 'New Article',
    createTitle: 'New Article',
    editTitle: 'Edit Article',
    batchDelete: 'Batch Delete',
    batchUpdateStatus: 'Batch Update Status',
    batchAssignAuthor: 'Batch Assign Author',
    confirmBatchDelete: 'Are you sure to delete the selected articles?',
    selectRows: 'Please select articles first',
    status: {
      draft: 'Draft',
      pending: 'Pending Review',
      pendingReview: 'Pending Review',
      published: 'Published',
      rejected: 'Rejected',
      offline: 'Offline',
    },
    source: {
      manual: 'Manual',
      ai: 'AI Generated',
    },
    scoreLevel: {
      excellent: 'Excellent',
      good: 'Good',
      warning: 'Needs Improvement',
      fail: 'Below Standard',
    },
    stats: {
      total: 'Total',
      draft: 'Draft',
      pending: 'Pending',
      published: 'Published',
      rejected: 'Rejected',
      offline: 'Offline',
    },
    actions: {
      viewLive: 'View Live',
      edit: 'Edit',
      aiRewrite: '🤖 AI Rewrite',
      preview: 'Preview',
      score: 'Score',
      reScore: 'Re-Score',
      submitReview: 'Submit Review',
      resubmit: 'Resubmit',
      review: 'Review',
      approve: 'Approve',
      reject: 'Reject',
      offline: 'Take Offline',
      delete: 'Delete',
      returnToDraft: 'Return to Draft',
      confirmOffline: 'Are you sure to take this article offline?',
      confirmDelete: 'Are you sure to delete this article?',
      scoreHint: 'SEO/GEO score must be ≥ 70 to submit for review',
      submitReviewIllegal: 'Article status does not allow submission — please ensure it is in draft state',
    },
    form: {
      keyword: 'Article title',
      keywordPlaceholder: 'Search title',
      language: 'Language',
      languagePlaceholder: 'Select language',
      category: 'Category',
      categoryPlaceholder: 'Select category',
      status: 'Status',
      statusPlaceholder: 'Select status',
      source: 'Source',
      sourcePlaceholder: 'Select source',
      author: 'Author',
      authorPlaceholder: 'Select author',
      authorFilter: 'Author',
      authorFilterPlaceholder: 'Search author name',
      scoreMin: 'Score Min',
      scoreMax: 'Score Max',
      scoreRange: 'Score Range',
      dateRange: 'Update Date',
      startDate: 'Start Date',
      endDate: 'End Date',
      title: 'Title',
      titlePlaceholder: 'Enter article title',
      titleRequired: 'Please enter article title',
      slug: 'Slug',
      slugPlaceholder: 'Auto-generated, can be modified',
      tags: 'Tags',
      tagsPlaceholder: 'Comma separated, e.g.: casino,guide,2025',
      articleSource: 'Article Source',
      sourceManual: 'Manual Write',
      sourceAI: 'AI Generate →',
      sourceAIHint: 'Redirects to AI Content Generator. Content generated there will appear in Article Management.',
      scheduledPublish: 'Schedule Publish',
      scheduledTime: 'Publish Time',
      scheduledTimePlaceholder: 'Select publish date & time',
      summary: 'Summary',
      summaryPlaceholder: 'Enter article summary',
      content: 'Content',
      coverImage: 'Cover Image',
      coverImageHint: 'Cover image is also used as OG Image by default',
      keywords: 'Related Keywords',
      keywordsPlaceholder: 'Search keywords from keyword center',
      relatedKeywordsHint: 'First keyword is the primary; the rest are secondary',
      keywordFilter: 'Target Keyword',
      keywordFilterPlaceholder: 'Filter articles by keyword',
      secondaryKeywords: 'Secondary Keywords',
      secondaryKeywordsPlaceholder: 'Select secondary keywords (multiple)',
      rejectReason: 'Rejection Reason',
      rejectReasonPlaceholder: 'Enter rejection reason',
      rejectReasonRequired: 'Please enter rejection reason',
      seoTitle: 'SEO Title',
      seoTitlePlaceholder: 'Recommended 50-60 characters',
      seoTitleCount: '{count} chars',
      seoTitleWarn: 'Recommended 50-60 chars for best SEO',
      seoDescription: 'Meta Description',
      seoDescriptionPlaceholder: 'Recommended 100-160 characters',
      seoDescCount: '{count} chars',
      seoDescWarn: 'Recommended 100-160 chars for best SEO',
      canonical: 'Canonical URL',
      canonicalPlaceholder: 'Canonical URL',
      metaRobots: 'Meta Robots',
      ogImage: 'OG Image',
      assignAuthor: 'Assign Author',
      assignAuthorPlaceholder: 'Select author',
      targetStatus: 'Target Status',
      articleType: 'Article Type',
      articleTypeRequired: 'Please select article type',
      articleTypePlaceholder: 'Select article type',
      languageRequired: 'Please select language',
      slugRequired: 'Please enter URL Slug',
      authorRequired: 'Please select author',
      seoTitleRequired: 'Please enter SEO Title',
      seoDescRequired: 'Please enter Meta Description',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: 'OG Title',
      ogDescription: 'OG Description',
      ogDescriptionPlaceholder: 'OG Description',
    },
    serp: {
      title: 'Google SERP Preview',
      urlExample: 'https://yoursite.com/article',
    },
    review: {
      title: 'Article Review',
      info: 'Article Info',
      seoScore: 'SEO/GEO Score',
      checkItems: 'Review Checklist',
      submitInfo: 'Submission Info',
      submittedBy: 'Submitted By',
      submittedAt: 'Submitted At',
      seoInfo: 'SEO Info',
      keywords: 'Target Keywords',
      wordCount: 'Word Count',
      chars: 'chars',
      comment: 'Review Comment',
      commentPlaceholder: 'Enter review comments (required when rejecting)',
      commentRequired: 'Please enter review comment when rejecting',
      btnReturnToDraft: 'Return to Draft',
      btnReject: 'Reject',
      btnApprove: 'Approve & Publish',
      approveSuccess: 'Article approved and published',
      rejectSuccess: 'Article rejected',
      confirmText: 'Are you sure you want to approve and publish this article?',
      returnSuccess: 'Returned to draft',
      checkHasTitle: 'Has title',
      checkHasSlug: 'Has slug',
      checkHasSeoTitle: 'Has SEO title',
      checkHasSeoDesc: 'Has meta description',
      checkHasCover: 'Has cover image',
      checkHasAuthor: 'Has named author',
      checkScorePass: 'SEO score ≥ 80',
      pass: 'Pass',
      warn: 'Warning',
      fail: 'Fail',
    },
    batchAuthor: {
      title: 'Batch Assign Author',
      label: 'Author',
      required: 'Please select an author',
      success: 'Author assigned successfully',
      apiFail: 'Batch assign author API failed. Please contact backend to confirm the endpoint is available.',
    },
    batchDeleteApiFail: 'Batch delete API failed. Please contact backend to confirm the endpoint is available.',
    batchUpdateStatusApiFail: 'Batch update status API failed. Please contact backend to confirm the endpoint is available.',
    loadDetailFailed: 'Failed to load article detail. Please close and retry to avoid overwriting the original content.',
    table: {
      cover: 'Cover',
      title: 'Title',
      category: 'Category',
      keywords: 'Target Keywords',
      author: 'Author',
      seoScore: 'SEO',
      geoScore: 'GEO',
      totalScore: 'Total Score',
      source: 'Source',
      status: 'Status',
      updateTime: 'Updated At',
      action: 'Actions',
    },
    tabs: {
      basic: 'Basic Info',
      seo: 'SEO Settings',
    },
    saveDraft: 'Save Draft',
    keywordRelSaveWarn: 'Article saved, but keyword relations failed to save — please retry in the editor',
    inlinkBtn: 'Internal Links',
    inlinkModalTitle: 'Internal Link Suggestions',
    inlinkInjectBtn: 'Insert Links ({n})',
    inlinkInjectOk: '{n} internal link(s) inserted into the content. Click "OK" to save the article.',
    inlinkEmpty: 'No candidate links found',
    inlinkHint: 'Selected links are inserted at the first occurrence of the anchor text in the body (headings excluded). Click "OK" to save the article afterwards, otherwise the links are lost.',
    inlinkNoneInsertable: 'Nothing to insert: candidates are already linked or the anchor text does not appear in the content',
    inlinkStatusLinked: 'Already linked',
    inlinkStatusMissing: 'Anchor text not in content',
    inlinkStatusSelf: 'Points to this article',
    inlinkReasonLinked: 'The content already links to {url}; no need to insert again',
    inlinkReasonMissing: 'The anchor text "{anchor}" does not appear in the content, so there is no place to insert. Add the phrase to the content and reopen suggestions, or add the link manually in the editor',
    inlinkReasonNoTarget: 'This candidate has no target URL and cannot be inserted',
    inlinkReasonSelf: 'The target is this article itself; self-links are not inserted',
    inlinkUnsavedTip: 'Internal links were inserted but not saved yet. Click "OK" to save the article; closing without saving discards them.',
    inlinkUnsavedConfirmTitle: 'Internal links not saved',
    inlinkUnsavedConfirmOk: 'Discard and close',
    inlinkUnsavedConfirmBack: 'Back to save',
    viewJsonLdBtn: 'JSON-LD',
    jsonLdModalTitle: 'JSON-LD Preview (read-only)',
    previewBtn: 'Preview',
    scoreBtn: 'Score First',
    submitReviewBtn: 'Submit for Review',
    scoreGateTooltip: 'SEO score must be ≥ 80 to submit for review (current: {score})',
    openLiveTitle: 'Open live H5 page',
    openAuthorTitle: 'Open author page (H5)',
    kwFilterBanner: 'Filtering by related keyword: ',
    kwFilterClear: 'Clear filter',
    liveBaseUrlMissing: 'Site base URL (h5BaseUrl) not configured; live page unavailable',
    liveUnavailable: 'Not published — live page unavailable',
    unsignedAuthor: 'Unsigned',
  },

  articleTag: {
    addBtn: 'Add Tag',
    backfillBtn: 'Backfill',
    listTitle: 'Tag Dictionary',
    frm: {
      tagName: 'Tag Name',
      tagNamePlaceholder: 'Search tag name',
      status: 'Status',
      statusAll: 'All',
    },
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled',
    },
    col: {
      tagName: 'Tag Name',
      status: 'Status',
      usageCount: 'Referenced Articles',
      createUser: 'Created By',
      updateTime: 'Updated At',
      action: 'Action',
    },
    deleteConfirmTitle: 'Delete Tag',
    deleteConfirmContent: 'Delete tag "{name}"?',
    deleteInUse: 'Tag is referenced by articles and cannot be deleted',
    deleteDisabledTip: 'Cannot delete while referenced articles > 0',
    edit: {
      createTitle: 'Add Tag',
      editTitle: 'Edit Tag',
      tagName: 'Tag Name',
      tagNamePlaceholder: 'Enter tag name',
      tagNameRequired: 'Tag name is required',
      status: 'Status',
      createOk: 'Tag created',
      saveOk: 'Tag saved',
      duplicate: 'Tag name already exists',
    },
    config: {
      title: 'Tagging Model Config',
      model: 'Tagging Model',
      modelPlaceholder: 'Select a model',
      modelRequired: 'Please select a tagging model',
      modelLoadFail: 'Failed to load model list; ensure the tagging model service is deployed',
      autoTagging: 'Enable Auto Tagging',
      saveOk: 'Config saved',
    },
    backfill: {
      title: 'Backfill Tagging',
      mode: 'Mode',
      manual: 'Manual (per article)',
      batch: 'Batch Job',
      scope: 'Scope',
      scopeToTag: 'Pending only',
      scopeAllPublished: 'All published',
      batchSize: 'Batch Size',
      limit: 'Max Count',
      limitExtra: 'Backfills published & untagged articles only, default 200',
      gotoManual: 'Go to Article Management',
      runBatch: 'Run Backfill',
      batchOk: 'Backfill job triggered',
    },
  },

  articleType: {
    title: 'Article Category Management',
    addNew: 'New Category',
    createTitle: 'New Category',
    editTitle: 'Edit Category',
    seoEditTitle: 'Configure SEO Template',
    saveAndSeo: 'Save & Configure SEO',
    seoConfig: 'Config SEO',
    seoConfigured: 'Configured',
    seoNotConfigured: 'Not Configured',
    tplVarHint: 'Available template variables: {categoryName} {total} {currentYear} {latestUpdate}',
    actions: {
      edit: 'Edit',
      seo: 'SEO Template',
      delete: 'Delete',
      confirmDelete: 'Are you sure to delete this category?',
        confirmDeleteName: 'Are you sure you want to delete category "{name}"?',
},
    form: {
      keyword: 'Category Name',
      keywordPlaceholder: 'Search category name',
      language: 'Language',
      languagePlaceholder: 'Select language',
      isActive: 'Status',
      isActivePlaceholder: 'Select status',
      seoConfigured: 'SEO Config',
      sortBy: 'Sort By',
      sortByManual: 'Manual',
      sortByArticleCount: 'Articles Desc',
      sortByUpdateTime: 'Recently Updated',
      languageRequired: 'Please select language',
      parent: 'Parent category',
      parentPlaceholder: 'Select parent category (optional)',
      name: 'Category Name',
      namePlaceholder: 'Enter category name',
      nameRequired: 'Please enter category name',
      slug: 'Slug',
      slugPlaceholder: 'Unique identifier, URL path',
      slugFormat: 'Slug allows lowercase letters, digits and hyphens only',
      seoKeywords: 'Meta Keywords',
      seoKeywordsPlaceholder: 'Comma separated (ignored by Google; optional)',
      slugRequired: 'Please enter slug',
      description: 'Description',
      descriptionPlaceholder: 'Enter category description',
      descPlaceholder: 'Enter category description (optional)',
      sortOrder: 'Sort Order',
      sortOrderPlaceholder: 'Lower number = higher position',
      seoTitleTpl: 'SEO Title Template',
      seoTitleTplPlaceholder: 'e.g. {categoryName} Guide {currentYear} | {total} Articles',
      seoDescTpl: 'Meta Description Template',
      seoDescTplPlaceholder: 'e.g. Explore {total} {categoryName} articles, last updated {latestUpdate}',
      schemaType: 'Schema Type',
      schemaTypePlaceholder: 'Select Schema type',
      hreflangList: 'Hreflang Association',
      hreflangListPlaceholder: 'e.g. en-US:/en/category/xxx,zh-CN:/zh/category/xxx',
    },
    table: {
      name: 'Category Name',
      language: 'Language',
      articleCount: 'Articles',
      seoTemplate: 'SEO Template',
      sortOrder: 'Sort',
      isActive: 'Status',
      updateTime: 'Updated At',
      action: 'Actions',
    },
    stats: {
      total: 'Total Categories',
      languages: 'Languages',
      articles: 'Total Articles',
      seoRate: 'SEO Rate',
      languageUnit: 'lang(s)',
      articleUnit: 'article(s)',
      balance: 'Platform Balance',
      balanceTip: 'Active categories with articles / Total categories',
    },
    tabs: {
      basic: 'Basic Info',
      seoTemplate: 'SEO Template',
    },
    schema: {
      collectionPage: 'CollectionPage',
      itemList: 'ItemList',
    },
    seo: {
      metaDescPreviewPlaceholder: 'Meta description will appear here…',
      serpPreview: 'SERP preview',
    },
  },

  keyWordCenter: {
    importSuccess: "Imported {success} successfully, {fail} failed",
    importEmpty: "No valid data detected, please check format",
    importLangMismatch: "row(s) with unrecognized intent/priority/language — the CSV may be exported in another UI language; switch to it and retry",
    exportEmpty: "No data under current filter",
    exportSuccess: "Exported {count} keywords",
    title: 'Keyword Intelligence Center',
    addNew: 'Add Keyword',
    createTitle: 'Add Keyword',
    editTitle: 'Edit Keyword',
    batchImport: 'Batch Import',
    batchDelete: 'Batch Delete',
    confirmBatchDelete: 'Are you sure to delete the selected keywords?',
    selectRows: 'Please select keywords first',
    importTitle: 'Batch Import Keywords',
    importHint: 'One keyword per line, format: keyword | intent | language | priority | monthly volume',
    importPlaceholder: 'keyword | intent | language | priority | monthly volume\nonline casino Philippines | transactional | en-US | high | 12400',
    importFormatHint: 'Supports comma, pipe, or tab separators. You can also upload an exported CSV (header auto-detected; status / generated-articles / updated-time columns are ignored). Existing keywords will be skipped automatically.',
    intent: {
        informational: 'Informational', info: 'Informational',
        navigational: 'Navigational', nav: 'Navigational',
        transactional: 'Transactional', trans: 'Transactional',
        commercial: 'Commercial', comm: 'Commercial',
      },
    confirmStatus: {
      PENDING: 'Pending',
      CONFIRMED: 'Confirmed',
      REJECTED: 'Rejected',
    },
    volumeSource: {
      gsc: 'GSC',
      dataforseo: 'DataForSEO',
      manual: 'Manual',
      unknown: 'Unknown',
    },
    volumeSourceGscNote: 'impressions',
    volumeStale: 'stale',
    generate: {
      disabledNotConfirmed: 'Confirm the intent before generating an article',
      disabledIsTypo: 'Typo keyword — use Merge instead of generating',
      disabledIsNav: 'Navigational keyword points to a function page — no article generated',
    },
    confirmIntentTitle: 'Confirm Intent',
    confirmIntentDesc: 'Confirm the search intent for this keyword:',
    confirmIntentSuccess: 'Intent confirmed',
    confirmNoEffect: 'No change applied: keyword may already be confirmed/rejected or failed backend validation; refresh and retry',
    merge: {
      title: 'Merge Typo Keyword',
      targetKeyword: 'Target keyword dataPkCode',
      targetPageUrl: 'Target landing page URL',
      success: 'Merged',
    },
    priority: {
        high: 'High',
        medium: 'Medium',
        low: 'Low',
      },
    // Backend intent dict intentCode → localized display label (display only; intentCode is still sent to backend)
    intentByCode: {
      informational: 'Informational', info: 'Informational',
      navigational: 'Navigational', nav: 'Navigational',
      transactional: 'Transactional', trans: 'Transactional',
      commercial: 'Commercial', comm: 'Commercial',
      comparison: 'Comparison',
      howto: 'How-to',
      localQuery: 'Local Query',
      news: 'News',
      question: 'Q&A',
    },
    coverage: {
      covered: 'Covered',
      uncovered: 'Uncovered',
    },
    actions: {
      edit: 'Edit',
      generate: 'Generate Article',
      confirmIntent: 'Confirm Intent',
      mergeTo: 'Merge To',
      archive: 'Archive',
      restore: 'Restore',
      delete: 'Delete',
      confirmDelete: 'Are you sure to delete this keyword?',
      confirmArchive: 'Are you sure to archive this keyword?',
      confirmRestore: 'Are you sure to restore this keyword?',
        quickConfirm: '✓ Confirm',
},
    form: {
      keyword: 'Keyword',
      keywordPlaceholder: 'Search keywords...',
      language: 'Language',
      languagePlaceholder: 'Select language',
      intent: 'Search Intent',
      intentPlaceholder: 'Select intent',
      intentDictHint: 'Optional — driven by the 9-class intent dictionary; can be confirmed later',
      confirmStatusPlaceholder: 'Confirm status',
      priority: 'Priority',
      priorityPlaceholder: 'Select priority',
      coverageStatus: 'Coverage',
      coveragePlaceholder: 'Select coverage status',
      name: 'Keyword',
      nameRequired: 'Please enter keyword',
      namePlaceholder: 'e.g. online casino Philippines',
      monthlyVolume: 'Monthly Volume',
      monthlyVolumePlaceholder: 'Estimated monthly search volume',
      intentRequired: 'Please select search intent',
      intentDesc: {
        info:  'User is seeking information or answers, e.g. "how to choose an online casino"',
        nav:   'User is looking for a specific site or brand, e.g. "[Your Brand] official login"',
        trans: 'User has clear sign-up or deposit intent, e.g. "casino register bonus"',
        comm:  'User is comparing products or services, e.g. "best Philippines online casino ranking"',
      },
      remark: 'Notes',
      remarkPlaceholder: 'Optional, add keyword context',
        volumeSource: 'Volume Source',
    volumeSourcePlaceholder: 'Select volume source',
},
    table: {
      keyword: 'Keyword',
      intent: 'Intent',
      confirmStatus: 'Confirm Status',
      priority: 'Priority',
      language: 'Language',
      monthlyVolume: 'Monthly Vol.',
      coveredArticleCount: 'Generated Articles',
      coverageStatus: 'Coverage',
      relatedArticles: 'Articles',
      updateTime: 'Updated At',
      articles: 'articles',
      action: 'Actions',
        searchIntent: 'Search Intent',
},
    stats: {
      total: 'Total Keywords',
      active: 'Active',
      weeklyNew: 'New This Week',
      archived: 'Archived',
      covered: 'Covered Articles',
      highPriority: 'High Priority',
      avgVolume: 'Avg Monthly Volume',
      avgVolumeEmpty: 'No data',
      avgVolumeBasis: 'Average computed from {n} of {m} keywords that have search volume data',
      avgVolumeLowSample: 'too few keywords have data — average is unreliable',
      thisWeek: 'this week',
      coverageRate: 'Coverage',
      needCover: 'need coverage',
        pendingConfirm: 'High-Priority Pending',
    generatable: 'Generatable',
    coveredArticles: 'Generated Articles',
},
    exportCsv: 'Export CSV',
    importConfirm: 'Start Import',
    importUploadText: 'Click or drag CSV file to upload',
    importUploadHint: 'Supports .csv or .txt files',
    selectedCount: '{count} selected',
    statusActive: 'Active',
    statusArchived: 'Archived',
    pleaseSelectStatus: 'Select status',
    batchDeleteUnavailable: 'Batch keyword deletion API is not yet available, please contact backend developer',
    batchImportFailed: 'Batch keyword import API call failed, please contact backend developer',
    exportMaxLimitWarn: 'Data exceeds {max} rows, only the first {max} will be exported',
    totalRows: 'Total {total}',
    keywordCol: 'Keyword',
    langDisplay: {
      'en-US': 'English',
      'zh-CN': '中文',
      'vi-VN': 'Tiếng Việt',
      'tl-PH': 'Filipino',
    },
    priorityFull: {
      high: 'High priority',
      medium: 'Medium priority',
      low: 'Low priority',
    },
    importPreview: 'Preview',
    importDone: 'Done',
    importConfirmWithCount: 'Confirm ({count})',
    importParsing: 'Parsing...',
    importParsedCount: 'Parsed {count} rows',
    importReupload: 'Re-upload',
    importStatusCol: 'Import result',
    importSelectAll: 'Select all',
    importDeselectAll: 'Deselect all',
    importSuccessCount: '✅ {count} succeeded',
    importFailCount: '❌ {count} failed',
    importExistSkipHint: 'Existing keywords will be skipped automatically.',
    importStatusSuccess: '✅ Success',
    miningReason: {
      duplicate: 'Duplicate keyword',
      keywordExist: 'Keyword already exists',
      invalidKeyword: 'Invalid keyword',
      langNotSupported: 'Language not supported',
      limitExceeded: 'Limit exceeded',
    },
    aiMining: {
      btn: 'AI Mining',
      title: 'AI Keyword Mining',
      description: 'AI will automatically mine related long-tail keywords based on your seed keyword and analyze the search intent of each term.',
      form: {
        seed: {
          label: 'Seed Keyword',
          extra: 'Enter a core keyword and AI will generate variants, long-tail terms, and question-based keywords around it',
        },
        directions: {
          label: 'Mining Directions',
          longTail: 'Long-tail variants (e.g. "best online casino PH 2025")',
          qa: 'Question keywords (e.g. "is online casino legal in Philippines")',
          compare: 'Comparison (e.g. "[Your Brand] vs competitor")',
          geo: 'Regional (e.g. "casino Manila", "casino Cebu")',
        },
        language: {
          label: 'Target Language',
          mixed: 'Mixed (Multilingual)',
        },
        competition: {
          label: 'Target Competition',
          extra: 'New sites should target low-competition keywords first to gain rankings faster',
          all: 'All competition levels',
          low: 'Low competition (easy to rank, good for new sites)',
          medium: 'Medium competition',
          high: 'High competition',
        },
        count: {
          label: 'Mining Count',
          fast: '10 keywords (Fast)',
          recommended: '20 keywords (Recommended)',
          deep: '30 keywords (Deep)',
        },
      },
      action: {
        start: 'Start AI Mining',
        add: 'Add to Keyword Center',
        close: 'Close',
      },
      loading: 'AI is analyzing search intent and long-tail keywords...',
      result: {
        title: 'Mining Results',
        note: 'Duplicates with existing keywords have been filtered out automatically. Select the terms you want to add, then click "Add to Keyword Center".',
      },
      intent: {
        informational: 'Informational', info: 'Informational',
        navigational: 'Navigational', nav: 'Navigational',
        transactional: 'Transactional', trans: 'Transactional',
        commercial: 'Commercial', comm: 'Commercial',
      },
      competition: {
        low: 'Low competition (easy to rank, good for new sites)',
        medium: 'Medium competition',
        high: 'High competition',
      },
      competitionCol: 'Competition',
      relevance: 'Relevance',
      selected: '{count} keywords selected',
      countUnit: 'keywords',
      estimatedCost: 'Est. cost: ~',
      seedRequired: 'Please enter a seed keyword',
      directionRequired: 'Please select at least 1 mining direction',
      addSuccess: 'Successfully added {count} keywords',
      selectAll: 'Select All',
      modelLabel: 'AI Model',
      modelRequired: 'Please select AI model',
      modelPlaceholder: 'Select AI model',
      addStatusCol: 'Add Status',
      addStatusSuccess: 'Success',
      addStatusFail: 'Failed',
      addResultEmptyWarn: 'Result data is missing — please refresh the list to confirm the keywords were added',
    },
      selectedRows: '{count} selected',
    batchConfirmUnavailable: 'Batch intent confirmation API not yet available',
    batchConfirmIntent: 'Batch Confirm Intent',
    batchConfirmTitle: 'Batch Confirm Intent',
    batchConfirmNoPending: 'No pending keywords in selection',
    batchConfirmNeedIntent: 'Please set an intent for at least one keyword',
    batchConfirmSuccess: 'Intents confirmed',
    batchMergeTypo: 'Batch Merge Typo',
    batchMergeNoTypo: 'No typo keywords in selection',
},

  score: {
      aiReworkBtn: "AI Rewrite",
      submitOnlyDraft: "Only draft articles can be submitted for review",
    title: 'SEO/GEO Scorer',
    checkArticle: 'Select Article',
    checkArticlePlaceholder: 'Select an article to score',
    startScore: 'Start Scoring',
    checkUrl: 'Score by URL',
    checkUrlPlaceholder: 'Enter article URL',
    checkContent: 'Enter Content Manually',
    articleTitle: 'Article Title',
    articleTitlePlaceholder: 'Enter article title',
    articleTitleRequired: 'Please enter article title',
    articleContent: 'Article Content',
    articleContentPlaceholder: 'Paste article HTML or plain text',
    articleContentRequired: 'Please enter article content',
    targetKeyword: 'Target Keyword',
    targetKeywordPlaceholder: 'Enter target keyword',
    seoDescription: 'Meta Description',
    seoDescriptionPlaceholder: 'Enter Meta Description',
    startCheck: 'Start Scoring',
    checking: 'Scoring...',
    totalScore: 'Total Score',
    seoScore: 'SEO Score',
    geoScore: 'GEO Score',
    level: {
      excellent: 'Publishable',
      good: 'Needs Optimization',
      warning: 'Needs Improvement',
      fail: 'Needs Revision',
    },
    checkItem: {
      status: {
        pass: 'Pass',
        warn: 'Warning',
        fail: 'Fail',
      },
    },
    seoGroup: 'SEO Checks',
    geoGroup: 'GEO Checks',
    suggestion: 'Optimization Suggestion',
    noResult: 'Please select an article to start scoring',
    tagSuggest: 'Suggest',
    tagTip: 'Tip',
    btnSubmit: 'Submit Review',
    btnContinue: 'Continue Optimizing',
    btnEdit: 'Go to Edit',
    btnAIRegenerate: 'AI Regenerate',
    btnRescore: 'Rescore',
    btnBackToEditor: 'Back to Editor',
    submitTooltipNoScore: 'Please run score first',
    submitTooltipBelow80: 'Need score ≥ 70 to submit review (current {{score}})',
    submitSuccess: 'Submitted for review successfully',
    submitFail: 'Submission failed, please try again',
    submitFailTransition: 'Status transition failed — article cannot be submitted in its current state',
    scoreFail: 'Scoring failed, please try again',
    scoreError: 'Scoring request error, please try again',
    history: 'Score History',
    historyEmpty: 'No score history',
    pleaseSelectModel: 'Please select AI model first',
    pleaseSelectArticle: 'Please select an article first',
    selectModelLabel: 'Select AI Model',
    selectModelPlaceholder: 'Select AI Model',
    articleSearchHint: 'Search by title',
    viewMore: 'View more',
    checks: {
      titleKeyword: 'Title contains target keyword',
      metaDescLength: 'Meta Description length is valid',
      headingStructure: 'H2/H3 heading structure is complete',
      keywordDensity: 'Keyword density is appropriate',
      internalLinks: 'Contains internal links',
      ogImage: 'OG image is configured',
      canonicalUrl: 'Canonical URL is configured',
      faqModule: 'Contains FAQ module',
      blufFormat: 'BLUF format (direct answer first)',
      namedAuthor: 'Named author + Person Schema',
      neutralTone: 'Neutral authoritative tone',
      comparisonTable: 'Contains comparison table',
      authorityData: 'Contains authoritative claims and data',
      freshness: 'Content freshness',
    },
      totalScoreFormula: '综合 = (SEO + GEO) / (70 + 70)',
    checkGroupMaxScore: '{{itemCount}} items · max {{max}}',
    btnRegenWithIssues: 'Regenerate with Issues',
    regenTooltipNoScore: 'Run scoring first before regenerating',
    regenTooltipPassed: 'Score already meets the threshold; regeneration is optional',
},
  aiGenerator: {
    reworkBanner: '🤖 AI Rework Mode: reworking "{title}" — clicking Save Draft will update the original article',
    title: 'AI Content Generator',
    cardTitle: 'Generate Parameters',
    previewTitle: 'Content Preview',
    historyTitle: 'Generation History',
    historyCount: 'Last 10',
    startBtn: 'Start AI Generation',
    saveDraft: 'Save Draft',
    saveDraftDone: 'Saved (Draft)',
    updateArticle: 'Update Article',
    goScoreBtn: 'Go to Score',
    goScore: '📊 Score',
    submitReview: '📤 Submit Review',
    submitReviewBtn: 'Submit for Review',
    emptyHint: 'Configure parameters and click “AI Generate”',
    emptySubHint: 'AI will generate a complete SEO + GEO optimized article',
    generating: 'AI is writing...',

    reuseParams: 'Reuse Params',
    viewHistory: 'View',
    historyTip: '"Reuse Params": regenerate using the same keyword, length, tone, etc. "View": preview previously generated content and save as draft.',
    form: {
      keyword: 'Target Keyword',
      keywordRequired: 'Please select a target keyword',
      keywordPlaceholder: 'Select from keyword center...',
      customKeyword: 'Or enter keyword directly',
      customKeywordPlaceholder: 'Enter custom keyword...',
      articleType: 'Article Type',
      author: 'Byline Author',
      authorRequired: 'Please select a byline author',
      authorPlaceholder: 'Select author...',
      coverImageSize: 'Cover Image Size',
      coverImageSizeRecommended: '(Recommended, OG Standard)',
      language: 'Language',
      wordCount: 'Article Length',
      extraReq: 'Extra Requirements',
      extraReqPlaceholder: 'e.g., emphasize PAGCOR license authority...',
      secondaryKeywords: 'Secondary Keywords (3-5)',
      secondaryKeywordsPlaceholder: 'Select from keyword center (multiple)',
      longTailQuestions: 'Long-tail Questions (3-5)',
      longTailQuestionsPlaceholder: 'One question per line',
      aiSuggestLongTailBtn: 'AI Suggest',
      aiSuggestLongTailNoKeyword: 'Select a target keyword first',
      aiSuggestLongTailEmpty: 'No question suggestions returned; enter manually',
      aiSuggestLongTailDisabledHint: 'AI suggestion API not available yet; enter manually',
      mustInclude: 'Must Include Facts',
      mustIncludePlaceholder: 'Facts the article must include',
      mustAvoid: 'Must Avoid',
      mustAvoidPlaceholder: 'Words/claims the article must avoid',
      targetWordCount: 'Target Word Count',
      wordsUnit: 'words',
      wordCountWarning: 'Target word count is outside the recommended range for this content type',
      presetApplied: 'Defaults applied for the selected content type',
      relatedEntities: 'Related Entities',
      relatedEntitiesPlaceholder: 'Select related entities',
      entityTypeFilter: 'Entity Type',
      entityTypeFilterPlaceholder: 'Filter by type',
      entityTypePerson: 'Person',
      entityTypeOrganization: 'Regulator',
      entityTypeProduct: 'Game',
      entityTypeConcept: 'Concept',
      entityTypePlace: 'Place',
      entityTypeBrand: 'Brand',
      entityTypeEvent: 'Activity',
      inlinkSuggest: 'Recommend Internal Links',
      inlinkSuggestBtn: 'Get Suggestions',
      inlinkSuggestEmpty: 'No candidate articles found',
      mustIncludeInlinks: 'Must-include Internal Links',
      entityRelSaveError: 'Failed to save entity relations, please retry',
      keywordIntent: {
        informational: 'Informational',
        navigational: 'Navigational',
        transactional: 'Transactional',
      },
      keywordVolume: 'Monthly Volume',
      keywordCovered: 'Covered',
      keywordUncovered: 'Not Covered',
      switchKeywordTitle: 'Switch Target Keyword',
      switchKeywordContent: 'Generation is in progress. Switching keyword will interrupt it. Continue?',
      contentType: 'Content Type',
      contentTypeRequired: 'Please select content type',
      contentTypePlaceholder: 'Select content type...',
      schemaType: 'Schema Type',
      schemaTypePlaceholder: 'Select schema type...',
      schemaTypeHint: 'Auto-suggested by content type; adjustable',
      geoMode: 'GEO Mode',
      geoModePlaceholder: 'Select GEO mode...',
      modelCode: 'Article Model',
      modelCodePlaceholder: 'Select article generation model',
      modelCodeRequired: 'Please select an article generation model',
      imageModelCode: 'Cover Image Model',
      imageModelCodePlaceholder: 'Select cover image model (optional)',
      imageModelCodeRequired: 'Please select a cover image generation model',
      imageModelCodeTip: 'Skip to generate faster without a cover image',
      langSimplifiedChinese: 'Simplified Chinese',
      category: 'Article Category',
      categoryPlaceholder: 'Select category (optional)',
      includeCitations: 'Include citations & external links',
      includeCitationsExtra: 'Includes cite tags or external links to enhance GEO authority score',
      includeFaq: 'Include FAQ Q&A paragraphs',
      includeFaqExtra: 'Contains Q&A-style H2 headings, improves GEO answer extraction score',
      contentLength: 'Article Length',
      contentLengthShort: 'Short (500-800 words)',
      contentLengthStandard: 'Standard (1000-2000 words)',
      contentLengthLong: 'Long (2500-4000 words)',
    },
    preview: {
      articleTitle: 'Article Title',
      articleTitleRequired: 'Please enter article title',
      articleTitlePlaceholder: 'Enter article title...',
      slug: 'URL Slug',
      slugRequired: 'Please enter URL slug',
      slugPlaceholder: 'Auto-generated, can be modified',
      scoreDisabledTip: 'Please save draft first',
      submitDisabledNoScore: 'Please complete scoring first',
      submitDisabledLowScore: 'Score below required threshold (≥60 needed)',
      summary: 'Article Summary',
      summaryPlaceholder: '2-3 sentence summary of the article...',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: 'Default: same as SEO Title',
      ogDescription: 'OG Description',
      ogDescriptionPlaceholder: 'Default: same as Meta Description',
      coverImage: 'Cover Image',
      coverImageHint: 'Recommended: 1200×630px, JPG/PNG/WEBP, max 2MB. Also used as OG Image.',
      aiGeneratedImage: 'AI Generated Cover Image',
      generateCoverImage: 'Generate Image',
      regenerateCoverImage: 'Regenerate Image',
      generatingImage: 'Generating cover image...',
      imageGenOk: 'Cover image generated successfully',
      imageGenEmpty: 'Image generation failed, please try again',
      regenerateImage: 'Regenerate Image',
      regenerateImageSuccess: 'Image regenerated successfully',
      regenerateImageFailed: 'Image generation failed, please retry',
      coverImageUploadFail: 'Cover image upload failed, please try again',
      noTaskForImage: 'AI image generation is not available in rewrite mode, please upload manually',
      selectImageModelFirst: 'Please select an image model first',
        metaDescWarnHint: 'Approaching limit, consider shortening',
    metaDescOverHint: 'Exceeds 200 character limit',
},
    articleType: {
      guide: '📖 In-depth Guide',
      review: '⭐ Review & Comparison',
      news: '📰 News',
      faq: '❓ FAQ',
    },
    wordCount: {
      standard: 'Standard (1500-2000 words)',
      short: 'Short (800-1200 words)',
      long: 'Long (2500-3500 words)',
    },
    historyStatus: {
      draft: 'Draft',
      published: 'Published',
      discarded: 'Discarded',
      pending_review: 'Pending Review',
    },
    historyCol: {
      time: 'Time',
      keyword: 'Target Keyword',
      articleTitle: 'Article Title',
      model: 'Model',
      score: 'Score',
      status: 'Status',
      action: 'Action',
        articleType: 'Content Type',
},
    steps: {
      config: 'Configure',
      generate: 'AI Generate',
      preview: 'Edit Preview',
      score: 'Score Check',
      submit: 'Submit Review',
    },
    genStep: {
      intent: 'Analyzing keywords and search intent',
      structure: 'Building article structure and headings',
      content: 'Writing body content and FAQ sections',
      meta: 'Generating SEO meta and OG fields',
      image: 'Generating cover image',
    },
    generatingSteps: {
      intent: 'Analyzing keyword search intent',
      research: 'Researching competitor content',
      content: 'Generating SEO-optimized body',
      faq: 'Creating FAQ pairs',
      meta: 'Generating Meta tags',
      links: 'Recommending internal links',
    },
    geoSectionTitle: '🧠 GEO Optimization Options',
    generateError: 'Generation Failed',
    generateErrorFallback: 'AI generation failed. Please try again.',
    retryBtn: 'Retry',
    articleTypeOpt: {
      deepGuide: '📖 In-depth Guide',
      review:    '⭐ Review & Comparison',
      news:      '📰 News',
      faq:       '❓ FAQ',
      tutorialGuide: '🎓 Tutorial',
      howto: '🎯 How-to Guide',
      comparison: '⭐ Review & Comparison',
      listicle: '📋 Listicle',
      landingPage: '🛬 Landing Page',
      brand:     'Brand',
      brandTypo: 'Brand Misspelling',
      nav:       'Navigational',
      trust:     '🛡️ Trust / Legitimacy',
      tutorial:  'Tutorial',
      local:     '📍 Local Landing Page',
      product:   '🎰 Product / Game Page',
      event:     '🎁 Promotion / Event',
      info:      'Informational',
    },
    geoModeOpt: {
      normal:           'Normal',
      normalDesc:       'Standard article structure, suitable for most content',
      bluf:             'BLUF Format (Recommended)',
      blufDesc:         'Bottom Line Up Front — leads with the answer, easier for AI search engines to extract snippets',
      compareTable:     'Comparison Table',
      compareTableDesc: 'Presents side-by-side comparisons in tables, ideal for product reviews and buying guides',
      qaCluster:        'Q&A Cluster',
      qaClusterDesc:    'Organizes content as a cluster of question-and-answer pairs',
      stepByStep:       'Step-by-step',
      stepByStepDesc:   'Numbered step-by-step instructions, ideal for tutorials/how-to',
      notReady: 'Not yet supported by backend; coming soon',
    },
    stepName: {
      configParams: 'Parse Parameters',
      aiGenerate:   'AI Generate',
    },
    unknownStatus: 'Unknown status {code}, please contact admin',
    pollingTimeout: 'Generation timed out. Polling stopped. Please refresh and retry.',
    cancelTaskBtn: 'Cancel Task',
    deleteTaskBtn: 'Delete',
    runScoreCheckBtn: 'Run Score Check',
    finalizeBtn: 'Finalize',
    taskHistoryTab: 'AI Generation Tasks',
    publishedArticlesTab: 'Published Articles',
    taskStatus: {
      created: 'Created',
      generating: 'Generating',
      editing: 'Editing',
      reviewing: 'Under Review',
      failed: 'Failed',
      cancelled: 'Cancelled',
      finalized: 'Finalized',
      unknown: 'Unknown',
    },
    phase: {
      created: 'Pending',
      generating: 'Generating',
      editing: 'Ready',
      reviewing: 'Reviewing',
      finalized: 'Finalized',
      failed: 'Failed',
      cancelled: 'Cancelled',
      unknown: 'Unknown',
    },
    msg: {
      saveDraftOk: 'Saved as draft. Find it in Article Management.',
      saveDraftFirst: 'Please save as draft first before submitting for review.',
      submitReviewConfirmTitle: 'Submit for Review',
      submitReviewConfirmContent: 'Submit this article for review?',
      submitReviewDisabledHint: 'Reach the required score before submitting for review',
      scoreFirst: 'Please complete SEO/GEO scoring (≥80) before submitting for review.',
      submitReviewOk: 'Submitted for review successfully.',
      viewPending: 'View historical content (pending API)',
      reuseOk: 'Params reused. Please reconfigure and generate.',
      submitReviewFieldsMissing: 'Submit review failed: missing required fields. Please check title and content.',
      pkCodeLookupFailed: 'Task created but task ID could not be resolved. Please refresh and retry.',
      articleIdMissing: 'Article saved, but article ID could not be obtained. Please refresh and continue editing.',
      cancelOk: 'Task cancelled.',
      deleteOk: 'Task deleted.',
      finalizeOk: 'Finalized. Find the article in Article Management.',
      cancelConfirmTitle: 'Cancel this generation task?',
      deleteConfirmTitle: 'Delete this generation task? This action cannot be undone.',
      scoreCheckStarted: 'Score check started.',
      contentSyncFailed: 'Content sync failed. Please save manually.',
      statusTransitionIllegal: 'This action is not supported in the current state.',
      noTaskForSubmit: 'No associated task found. Please generate an article via AI first.',
    },
  },
  siteLink: {
    title: 'Internal Links',
    addBtn: 'Add Rule',
    cardTitle: 'Internal Link Rules',
    tip: 'Links are automatically injected during SSR rendering. Existing manual links in articles are not duplicated. Rules are auto-paused when target URL goes offline.',
    deleteOk: 'Rule deleted',
    offlineTip: 'Target offline',
    hitCountLabel: 'Hit {n} articles',
    stat: {
      total: 'Total Rules',
      enabledRules: 'Enabled',
      hitArticles: 'Hit Articles',
      totalHits: 'Total Hits',
    },
    col: {
      ruleName: 'Rule Name',
      keyword: 'Keyword',
      targetUrl: 'Target URL',
      lang: 'Language',
      hitArticles: 'Hit Articles',
      lastHit: 'Last Hit',
      status: 'Status',
      action: 'Action',
    },
    drawer: {
      title: 'Hit Details',
      articleId: 'Article ID',
      hitCount: 'Hits',
      lastHit: 'Last Hit',
      action: 'Action',
      viewArticle: 'View Article',
      empty: 'No articles have triggered this rule yet',
    },
    statusLabel: {
      enabled: 'Enabled',
      disabled: 'Paused',
    },
    edit: {
      createTitle: 'Add Internal Link Rule',
      editTitle: 'Edit Internal Link Rule',
      ruleName: 'Rule Name',
      ruleNameRequired: 'Please enter a rule name',
      ruleNamePlaceholder: 'e.g.: PAGCOR license guide link',
      lang: 'Language',
      langRequired: 'Please select a language',
      langPlaceholder: 'Select language',
      sourcePattern: 'Trigger Keyword / Pattern',
      sourcePatternRequired: 'Please enter a trigger keyword or pattern',
      sourcePatternPlaceholder: 'e.g.: PAGCOR license',
      keywordExtra: 'When this keyword appears in article body, it will automatically become a link. Case-insensitive.',
      targetUrl: 'Target URL',
      targetUrlRequired: 'Please enter a target URL',
      targetUrlPlaceholder: 'e.g.: /article/pagcor-casino-guide',
      targetUrlExtra: 'Must be an internal URL starting with /',
      anchorText: 'Anchor Text',
      anchorTextPlaceholder: 'Default: uses the keyword itself',
      matchType: 'Match Type',
      matchTypeExtra: 'Exact: matches only the exact word. Contains: matches any occurrence. Regex: use regular expressions.',
      exactMatch: 'Exact Match — exact word only (recommended)',
      containsMatch: 'Contains Match — matches partial text',
      regexMatch: 'Regex Match — use regular expression',
      maxPerPage: 'Max Replacements Per Page',
      maxLinksExtra: 'Maximum links generated for the same keyword in one article. Usually 1 is sufficient.',
      priority: 'Priority',
      priorityTooltip: 'Higher priority (larger number) means the rule is matched first. When multiple rules have overlapping keywords, higher-priority rules take effect first. Long/exact phrases should have higher priority.',
      status: 'Status',
      statusEnabled: 'Enabled',
      statusDisabled: 'Paused',
      saveOk: 'Rule updated',
      createOk: 'Rule created',
      regexConfirmTitle: 'Use regex matching?',
      regexConfirmContent: 'Invalid regex may break page rendering. Make sure you understand regex syntax.',
      lockedTooltip: 'To change language or match type, delete this rule and create a new one',
      applyScopeWarning: 'This rule applies to all published articles of the selected language. Per-category or excluded-article scoping is not supported.',
      advancedSettings: 'Advanced settings',
      priorityHigh: 'High (matches first)',
      priorityMedium: 'Medium (default)',
      priorityLow: 'Low',
      articlePickerLabel: 'Pick from published articles (optional)',
      articlePickerPlaceholder: 'Search article title',
      articlePickerNeedLang: 'Select language first',
      articlePickerExtra: 'Selecting an article fills in the target URL above',
      conflictTitle: 'Keyword conflict detected',
      conflictDesc: 'The new rule contains or is contained by these existing rules. Higher-priority rule wins on match. Continue?',
    },
    frm: {
      keyword: 'Keyword',
      keywordPlaceholder: 'Search keyword or URL...',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'Search by rule name...',
      status: 'Status',
      statusAll: 'All Status',
      lang: 'Language',
      langPlaceholder: 'All Languages',
    },
      deleteConfirmTitle: 'Confirm Delete',
    deleteConfirmContent: 'This action cannot be undone. The rule and all related data will be permanently removed.',
    deleteConfirmOk: 'Delete',
},
  siteMap: {
    status: {
      included: 'Included',
      waiting: 'Pending',
      excluded: 'Excluded',
    },
    title: 'Sitemap Management',
    regenBtn: 'Regenerate',
    viewXmlBtn: 'View XML',
    viewAuthorsXmlBtn: 'Authors XML',
    authorsXmlPending: 'Backend API pending',
    syncAuthorTip: 'Sync author pages into sitemap, then preview XML',
    syncAuthorOk: 'Author pages synced',
    regenOk: 'Sitemap regenerated',
    cardTitle: 'Path Inclusion Config',
    xmlModalTitle: 'sitemap.xml Preview',
    toggleFail: 'Action failed, reverted',
    addBtn: 'Add URL',
    xmlEmpty: 'Click \'View XML\' to generate',
    xmlLoading: 'Generating…',
    frm: {
      pageType: 'Page Type',
      lang: 'Language',
      localIndexStatus: 'Index Status',
    },
    col: {
      path: 'Path Pattern',
      pageUrl: 'Page URL',
      type: 'Type',
      pageType: 'Page Type',
      lang: 'Language',
      include: 'Include',
      localIndexStatus: 'Index Status',
      changefreq: 'Update Frequency',
      priority: 'Priority',
      action: 'Actions',
    },
    edit: {
      titleNew: 'Add Sitemap URL',
      titleEdit: 'Edit Sitemap URL',
      pageTypeRequired: 'Please select page type',
      pageTypePlaceholder: 'Select page type',
      pageUrlRequired: 'Please enter page URL',
      pageUrlInvalid: 'Please enter a valid URL (relative path like /article/slug or full URL like https://example.com/page)',
      pageUrlPlaceholder: '/article/my-slug or https://example.com/page',
      langRequired: 'Please select language',
      langPlaceholder: 'Select language',
      includeInSitemap: 'Include in sitemap.xml',
      includeInSitemapHint: 'Only pages with status "Included" are output to sitemap.xml',
    },
    stat: {
      total: 'Total Pages',
      indexed: 'Indexed',
      pending: 'Pending Index',
      excluded: 'Excluded',
    },
    pageType: {
      home:     'Home',
      article:  'Article',
      category: 'Category',
      login:    'Login',
      author:   'Author',
      template: 'Template',
    },
    freq: {
      always: 'Always',
      hourly: 'Hourly',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yearly: 'Yearly',
      never: 'Never',
    },
    xmlModal: {
      urlLabel: 'URL: ',
      copyBtn: 'Copy',
      copyOk: 'Copied to clipboard',
      indexFileLabel: '{file} (sitemap index · aggregates per-language sitemaps)',
      langFileLabel: '{file} ({lang} sub-sitemap)',
      copyFail: 'Copy failed',
      lastGenLabel: 'Last generated: ',
      openNewTab: 'Open /sitemap.xml in new tab',
      closeBtn: 'Close',
    },
    statDesc: {
      title: 'Metrics Reference',
      total: 'Total sitemap URLs actually generated by the SSR server, including all enabled path patterns.',
      indexed: 'From Google Search Console API, synced daily — pages that Google has already indexed.',
      pending: 'Total pages minus indexed — submitted but not yet processed by Google.',
      excluded: 'From Google Search Console — pages excluded by noindex tags or robots rules.',
      gscTip: 'Indexed and Excluded data require Google Search Console API integration. Shows — when not connected.',
    },
  },
  declDoc: {
    title: 'Site Declaration Files',
    robotsTab: 'robots.txt',
    llmsTab: 'llms.txt',
    save: 'Save',
    saveOk: 'Saved',
    saveFailed: 'Save failed',
    publish: 'Publish',
    publishOk: 'Published successfully',
    publishFailed: 'Publish failed',
    robotsDesc: 'Controls search engine and AI crawler access. Use the toggles on the right for quick AI crawler control.',
    advancedWarn: '⚠️ Advanced mode: incorrect robots rules may block your entire site. Verify syntax before saving.',
    llmsDesc: 'A site description file for AI engines. Tells AI what your site is about and how to cite it.',
    botSwitchTitle: 'AI Crawler Quick Toggles',
    botTip: '💡 GEO requires allowing AI crawlers. Disabling will prevent that AI engine from citing your articles.',
    siteUrlInvalid: 'Please enter a valid site domain (e.g. https://example.com)',
    siteUrlLabel: 'Site Domain',
    siteUrlHint: 'Used for both robots.txt Sitemap line and llms.txt article URLs (shared across tabs)',
    brandNameLabel: 'Brand Name',
    brandNamePlaceholder: 'e.g. [Your Brand]',
    taglineLabel: 'Tagline',
    taglinePlaceholder: 'e.g. PAGCOR licensed online casino',
    statusPublished: 'Published',
    statusDraft: 'Draft',
    saveAndPublish: 'Save & Publish',
    robotsInfoBanner: 'Toggle AI crawler access; takes effect in robots.txt after save & publish',
    brandIntroLabel: 'Brand Intro',
    brandIntroPlaceholder: '2-3 sentences about your brand positioning, license, core services',
    guidesAutoTitle: 'Guides (auto-generated from published articles in this language)',
    guidesEmpty: 'No published {lang} articles',
    guidesLangName: { 'en-US': 'English', 'zh-CN': 'Chinese', 'vi-VN': 'Vietnamese', 'tl-PH': 'Filipino' },
    guidesError: 'Failed to load articles',
    previewTitle: 'Live Preview',
    langLoadFail: 'Failed to load language list (possible cross-module permission issue); fell back to default language. Please ask backend to check the multilingual management API permission.',
      historyBtn: 'History',
    historyDrawerTitle: 'Version History',
    historyColVersion: 'Version',
    historyColStatus: 'Status',
    historyColTime: 'Time',
    historyColAction: 'Action',
    historyEmpty: 'No version history',
    historyLoadFailed: 'Failed to load history',
    historyNoContent: '(no content)',
    rollbackBtn: 'Rollback',
    rollbackConfirmTitle: 'Confirm Rollback',
    rollbackConfirmContent: 'This will restore the selected version as the new draft. Continue?',
    rollbackConfirmOk: 'Confirm',
    rollbackConfirmCancel: 'Cancel',
    rollbackOk: 'Rolled back successfully',
    rollbackFailed: 'Rollback failed',
    llmsInfoBanner: 'llms.txt helps AI crawlers understand your brand and cite your content accurately.',
},
  health: {
    title: 'SEO Health Check',
    rescanBtn: '🔄 Rescan',
    scanNowBtn: 'Run Scan',
    emptyHint: 'No snapshot yet. Run the first scan to populate data.',
    scanOk: 'Scan complete. Score: ',
    scanFailed: 'Scan failed',
    scanResultEmpty: 'Scan returned no data, please try again later',
    loadFailed: 'Load failed',
    resolveOk: 'Marked as resolved',
    resolveFailed: 'Action failed',
    scanTimeLabel: 'Last Scan',
    contentFreshnessLabel: 'Freshness',
    authorCoverageLabel: 'Author Coverage',
    schemaLabel: 'Schema',
    crawlerAccessLabel: 'Crawler Access',
    severityHigh: 'high',
    severityMedium: 'medium',
    severityLow: 'low',
    resolvedTag: 'resolved',
    allHealthy: 'All checks passed 🎉',
    noIssues: 'No issues',
    staleCard: 'Content Freshness',
    staleCount: 'expired',
    staleDesc: 'AI prefers content <13 weeks old. Articles not updated in 90+ days need refreshing.',
    staleModalTitle: 'Stale Articles',
    staleModalClose: 'Close',
    authorCard: 'Author Coverage',
    authorDesc: 'E-E-A-T requires every article to have a byline author + Person Schema.',
    authorManageBtn: 'Manage Authors >',
    unsignedViewBtn: 'View Unsigned Articles >',
    unsignedModalTitle: 'Unsigned Published Articles',
    unsignedAssignBtn: 'Assign Author',
    unsignedEmpty: 'All published articles have authors',
    schemaCard: 'Schema Coverage',
    schemaDesc: 'SSR auto-injects structured data. Focus on articles missing author info.',
    cwvCard: 'Core Web Vitals',
    cwvDesc: 'Source: Google PageSpeed Insights (PSI), real user data from the past 28 days.',
    cwvWaitingPsi: 'PSI source pending',
    col: {
      target: 'Target',
      severity: 'Severity',
      action: 'Action',
      articleTitle: 'Title',
      publishTime: 'Published',
    },
    actionEdit: 'Edit',
    actionAiRefresh: 'AI Refresh',
    actionMarkResolved: 'Mark Resolved',
    cwv: {
      lcp: 'LCP (Largest Contentful Paint)',
      inp: 'INP (Interaction to Next Paint)',
      cls: 'CLS (Cumulative Layout Shift)',
      lcpHint: 'Good < 2.5s',
      inpHint: 'Good < 200ms',
      clsHint: 'Good < 0.1',
      ratingGood: 'Good',
      ratingNeedsImprovement: 'Needs Improvement',
      ratingPoor: 'Poor',
      ratingUnknown: '—',
    },
      actionReopen: 'Reopen',
    reopenOk: 'Issue reopened',
    reopenFailed: 'Failed to reopen',
    schemaModalTitle: 'Schema Coverage Issues',
    showResolved: 'Show resolved',
},
  pageModel: {
    pageType: {
      home: 'Home',
      login: 'Login',
      news: 'Article List',
      'news-category': 'Article Category',
      loading: 'Landing Page',
      'authors-list': 'Authors List',
    },
    title: 'Page SEO Templates',
    addBtn: '+ New Page SEO',
    cardTitle: 'Page SEO Templates',
    alertTip: 'Manage SEO Meta info for fixed pages (Home, VIP, Promo, etc.). Each page is configured independently per language. Article SEO is configured in Article Management.',
    allConfiguredTip: 'All fixed pages are already configured',
    notSet: 'Not Set',
    ogMissing: 'No OG',
    missingDesc: 'No Description',
    editBtn: 'Edit',
    deleteBtn: 'Delete',
    deleteConfirm: 'Are you sure you want to delete this template?',
    deleteOk: 'Template deleted successfully.',
    deleteError: 'Failed to delete template. Please try again.',
    loadError: 'Failed to load data. Please try again.',
    emptyText: 'No page SEO templates found',
    toggleError: 'Failed to update status. Change reverted.',
    frm: {
      keyword: 'Search',
      keywordPlaceholder: 'Search page name',
      pageKey: 'Page Key',
      pageKeyPlaceholder: 'Search by page key (slug)',
      language: 'Language',
      languagePlaceholder: 'Select language',
      pageType: 'Page Type',
      pageTypePlaceholder: 'Select page type',
      status: 'Status',
      statusPlaceholder: 'Select status',
      statusEnabled: 'Enabled',
      statusDisabled: 'Disabled',
    },
    col: {
      pageName: 'Page Name',
      pageKey: 'Page Key',
      language: 'Language',
      titleDesc: 'SEO Title / Description',
      og: 'OG',
      robots: 'Robots',
      enabled: 'Enabled',
      action: 'Action',
    },
    edit: {
      createTitle: 'New Page SEO Template',
      editTitlePrefix: 'Edit Page SEO — ',
      pageType: 'Page Type',
      pageTypeRequired: 'Please select a page type',
      pageTypePlaceholder: 'Select page type',
      pageTypeExtra: 'Cannot be changed after creation',
      language: 'Language',
      languageExtra: 'Cannot be changed after creation',
      seoTitle: 'SEO Title',
      seoTitleExtra: 'Recommended 50-60 chars, supports variables: {platform} {currentYear}',
      seoTitlePlaceholder: 'Enter the SEO title shown on search results',
      seoTitleRequired: 'Please enter SEO Title',
      metaDesc: 'Meta Description',
      metaDescExtra: 'Recommended 100-160 chars',
      metaDescPlaceholder: 'Enter the meta description shown on search results',
      metaDescRequired: 'Please enter Meta Description',
      canonical: 'Canonical URL',
      canonicalPlaceholder: 'https://example.com',
      canonicalExtra: "Canonical URL. SSR auto-injects <link rel='canonical'>",
      canonicalInvalid: 'Please enter a valid URL (e.g. https://example.com)',
      pageName: 'Page Display Name',
      pageNameRequired: 'Please enter a page display name',
      pageNamePlaceholder: 'e.g. Home, VIP, Promotions',
      langRequired: 'Please select a language',
      metaKeywords: 'Meta Keywords',
      metaKeywordsPlaceholder: 'Comma-separated keywords',
      loadError: 'Failed to load template data.',
      ogSync: 'Sync SEO Title / Description',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: 'Leave blank to use SEO Title',
      ogDesc: 'OG Description',
      ogDescPlaceholder: 'Leave blank to use Meta Description',
      ogSection: 'Social Sharing (Open Graph)',
      ogImage: 'OG Image',
      ogImagePlaceholder: 'https://yoursite.com/og-image.jpg',
      ogImageExtra: 'Recommended 1200×630 — shown on Facebook / Twitter / LinkedIn share cards',
      ogUploadText: 'Upload OG Image',
      serpPreviewTitle: 'Google SERP Preview',
      serpPreviewHint: 'Preview updates as you type. Google may display different text.',
      cancel: 'Cancel',
      save: 'Save',
      saveOk: 'SEO template updated',
      createOk: 'SEO template created',
      saveError: 'Save failed. Please try again.',
      enabled: 'Status',
      enabledOn: 'Enabled',
      enabledOff: 'Disabled',
    },
      ogComplete: 'Complete',
},
  author: {
    titleAdd: 'Add Author',
    titleEdit: 'Edit Author',
    addBtn: 'Add Author',
    viewAuthorPage: 'View author page',
    viewAuthorPageUnavailable: 'Site base URL (h5BaseUrl) not configured; author page unavailable',
    col: {
      avatar: 'Avatar',
      displayName: 'Display Name',
      slug: 'Slug',
      jobTitle: 'Job Title',
      socials: 'Socials',
      articleCount: 'Articles',
      status: 'Status',
      createTime: 'Created At',
      authorPage: 'Author Page',
      action: 'Actions',
        expertiseTags: 'Expertise',
    redditNoSameAs: 'Reddit — not included in sameAs (per SOP)',
},
    form: {
      displayName: 'Display Name',
      displayNameRequired: 'Please enter display name',
      displayNamePlaceholder: 'Author display name',
      slug: 'Slug (author page URL)',
      slugRequired: 'Please enter slug',
      slugFormat: 'Slug must be lowercase letters and hyphens (kebab-case)',
      slugTaken: 'This slug is already taken, please choose another',
      slugPlaceholder: 'e.g. jomar-dela-cruz',
      jobTitle: 'Job Title',
      jobTitleRequired: 'Please enter job title',
      jobTitlePlaceholder: 'e.g. Senior Content Editor',
      location: 'Location',
      expertiseTags: 'Expertise Tags (3-5, knowsAbout)',
      expertiseTagsTip: 'Press enter to add',
      quoteHighlight: 'Quote Highlight',
      quoteHighlightPlaceholder: 'Author signature quote (shown on author page)',
      joinedAt: 'Joined At',
      avatar: 'Avatar (≥400px)',
      uploadAvatar: 'Upload',
      bio: 'Bio',
      bioPlaceholder: 'Author bio',
      socials: 'Socials (LinkedIn required)',
      linkedinRequired: 'LinkedIn is required and cannot be removed',
      addSocial: 'Add Social',
      platform: 'Platform',
      handle: 'Handle',
      url: 'URL',
      sameAs: 'sameAs',
      exclude: 'Exclude',
      status: 'Status',
      enabled: 'Enabled',
      disabled: 'Disabled',
        editorialApproach: 'Editorial Approach',
    editorialApproachPlaceholder: 'Describe this author\'s editorial style and standards',
    previewSchema: 'Preview Person Schema (JSON-LD)',
},
    frm: {
      displayNamePlaceholder: 'Search display name',
      jobTitlePlaceholder: 'Search job title',
      statusPlaceholder: 'Select status',
    },
    msg: {
      createOk: 'Created',
      updateOk: 'Updated',
      socialsSaveWarn: 'Author saved, but social accounts failed to save; please edit and save again',
      operateFail: 'Operation failed',
      linkedinRequired: 'LinkedIn is required (URL needed)',
      avatarFormat: 'Only JPG/PNG/WEBP supported',
      avatarMaxSize: 'Image must be smaller than 2MB',
      avatarTooSmall: 'Avatar must be ≥400×400px',
      urlInvalid: 'Please enter a valid URL (starting with http(s)://)',
      deleteConfirm: 'Are you sure to delete this author?',
      view: 'View',
        schemaSaveFirst: 'Save the author first to preview Person Schema.',
    schemaLoadFail: 'Failed to load Person Schema preview.',
},
      infoBanner: 'More complete author profiles (job title + expertise + LinkedIn) produce stronger Person schema, helping AI engines identify the author as a domain authority.',
      infoBannerTitle: 'Author profiles affect Person schema strength',
},
  siteBaseUrl: {
    title: 'Site Base URL (h5BaseUrl)',
    declModeTip: 'Stored in Site Declaration (fileType=siteConfig). Saving publishes a new version; H5 SSR reads the latest published value.',
    currentPublished: 'Current published',
    publishBtn: 'Save & Publish',
    publishOk: 'Published',
    addBtn: 'Add Config',
    notReady: 'Backend not ready',
    notReadyTip: 'The site config API has not been implemented yet (no Taylor contract). All write operations are disabled.',
    col: {
      platform: 'Platform',
      env: 'Environment',
      h5BaseUrl: 'H5 Base URL',
      remark: 'Remark',
      updateTime: 'Update Time',
      action: 'Actions',
    },
    edit: {
      titleNew: 'Add Site Config',
      titleEdit: 'Edit Site Config',
      platformRequired: 'Please enter platform',
      envRequired: 'Please select environment',
      envPlaceholder: 'Select environment',
      h5BaseUrlRequired: 'Please enter H5 base URL',
      h5BaseUrlInvalid: 'Please enter a valid URL starting with http(s)://',
      h5BaseUrlTip: 'No trailing slash, e.g. https://www.fbmplay.com',
    },
  },
};
